import * as React from "react"
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Grid } from "@material-ui/core";
import BlogCard from "./BlogCard";
import Section from "../Section";
import RowsSectionHeader from "../RowsSectionHeader";
import { SECTION_WHITE, SECTION_PADDING_Y } from "../../styles/homepageSections";

interface BlogPost {
    id: string
    description: string;
    title: string;
    image: string;
    link: string;
}
interface Props {
    title: string;
    blogPosts: BlogPost[];
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: SECTION_PADDING_Y.mobile,
            [theme.breakpoints.up("md")]: {
                padding: SECTION_PADDING_Y.desktop,
            },
        },
        posts: {
            padding: '24px 0 0',
            [theme.breakpoints.up("md")]: {
                padding: '32px 0 0',
            },
        },
    }),
);

const BlogPosts: React.FC<Props> = ({ title, blogPosts }) => {
    const classes = useStyles();

    return <Section color={SECTION_WHITE}>
        <div className={classes.root}>
            {title && <RowsSectionHeader title={title} />}
            <Grid container spacing={3} className={classes.posts}>
                {blogPosts.map(post => <Grid item xs={12} sm={6} md={4} key={post.id}>
                    <BlogCard
                        title={post.title}
                        description={post.description}
                        imageUrl={post.image}
                        link={post.link}
                    />
                </Grid>)}
            </Grid>
        </div>
    </Section>
}

export default BlogPosts
